module.exports = __webpack_public_path__ + "assets/map-view.3e81f16b.svg";